export default [{
  path: '/applicationCandidates/:vacancyUuid',
  name: 'applicationCandidates',
  meta: {
    layout: 'empty',
  },
  component: () => import('@/views/applicationCandidates/index')
}]
